import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

import { AuthServiceGuest } from './../../services/AuthServiceGuest';
import { GuestsService } from './../../services/GuestsService';

import { Guest } from './../../dataTypes/Guest';
import { Site } from './../../dataTypes/Site';

import { CurrentUser } from './../../dataTypes/CurrentUser';

import { LanguageService } from './../../services/LanguageService';
import { LanguageConstants } from './../../common/language/LanguageConstants';
import * as _ from 'lodash';
import { MatDialog } from '@angular/material';
import { EditGuestDialog } from './saveGuest/editGuest.dialog';
import { MessageToUserDialog } from '../../shared/dialog/messageToUser.dialog';
import { Park } from '../../dataTypes/Park';
import { ParkForReservedSubscriber } from '../../dataTypes/ParkForReservedSubscriber';

@Component({
    selector: 'parks',
    templateUrl: './Parks.html',
})

export class Parks {

    public language = 'en';
    public languageConstants = LanguageConstants['en'];
    public rtl = false;

    displayedColumns: string[] = [];
      //'id', 'parkDescription', 'isPermitted', 'isUnlimited', 'totalPlacesForCompany',

      //'usedPlacesByGuests',
      //'usedPlacesByRegularSubscribers',
      //'usedPlacesByReservedSubscribers',
      //'totalUsedPlaces',
      
      //'freePlacesForRegularSubscribersAndGuests',
      //'freePlacesForReservedSubscribers',

      //'overflowLevel', 'maxSubsToOverflow'];

  

  public _parksList: Park[] = [];
  public _isAtidim: boolean;

    public _errorFromServer: string;

    public user: CurrentUser;

  constructor(public _language: LanguageService,
              public _GuestsService: GuestsService,
              public _AuthService: AuthServiceGuest,
              public _dialog: MatDialog) {

        this._language.language$.subscribe(
            language => {
                this.language = language;
                this.languageConstants = LanguageConstants[this.language];
            });
        this._language.rtl$.subscribe(
            rtl => {
                this.rtl = rtl;
            });
 }

  ngOnInit(): void
  {
    const self = this;
    self._isAtidim = false;
    this.displayedColumns = [
      'id', 'parkDescription', 'isPermitted', /*'isUnlimited',*/ 'totalPlacesForCompany',
      

      //'usedPlacesByGuests',uncomment for not atidim
      'usedPlacesByRegularSubscribers',
      'usedPlacesByReservedSubscribers',
      'totalUsedPlaces',

      'freePlacesForRegularSubscribersAndGuests',
      'freePlacesForReservedSubscribers',
];

    self.user = self._AuthService.getUserInfo();

    self._GuestsService.selectedCompanySubject.subscribe(
      data => {
        if (data) {
          self.getOverflowLevels();
          self.getParksList();
        }
      }
    );

    if (self._GuestsService._selectedCompany) {

      self.getOverflowLevels();
      self.getParksList();
    }
  }


  getOverflowLevels() {

    const self = this;

    self._GuestsService.getOverflowLevels()
      .subscribe((data: boolean) => {

        

        if (data === true) { // is Atidim

          self._isAtidim = true;
          this.displayedColumns = [
            'id', 'parkDescription', 'isPermitted', /*'isUnlimited',*/ 'totalPlacesForCompany',

            'overflowLevel', 'maxSubsToOverflow',

           // 'usedPlacesByGuests',
            'usedPlacesByRegularSubscribers',
            'usedPlacesByReservedSubscribers',
            'totalUsedPlaces',

            'freePlacesForRegularSubscribersAndGuests',
            'freePlacesForReservedSubscribers',

            'overflowsInPark'
          ];
        }
      },
        error => { }
      );
  }

  getParksList() {

    const self = this;

    self._GuestsService.getParks()
      .subscribe((data: Park[]) => {

        self._parksList = data;
      },
        error => { }
      );
  }

}

